<template>
    <div id="select_roles" class="m-5">
        <b-button class="m-3 p-2 px-5" pill @click="loginAs('VIP')">
            {{$t("loginasVIP")}}
        </b-button>
        <br/>
        <b-button class="m-3 p-2 px-5" pill @click="loginAs('FAN')">
            {{$t("loginasFAN")}}
        </b-button>
    </div>
</template>

<script>
export default {
    methods: {
        loginAs(role) {
            this.$store.commit('setUserRole', role);
            this.$emit('setUserRole', role);
        }
    },
    i18n: {
        messages: {
            en: {
                loginasVIP: 'Login as VIP',
                loginasFAN: 'Login as FAN'
            },
            it: {
                loginasVIP: 'Entra come VIP',
                loginasFAN: 'Entra come FAN'
            }
        }
    }
};
</script>
